import { useState } from 'react'
import { Modal, Button, SettingsRow, Toggle } from '@ofself/shell'
import { buildMarkdown, buildHTML, download, printHTML, fileName } from './export.js'
import { qh } from './qh.js'

/* EXPORT A WORD (owner call 2026-09-19, ink's ⋯ row brought over): pick a
   format, choose whether the word's facts ride along, and the file comes
   down. The kit's Modal and its SettingsRow — nothing dressed here. The Modal
   stays MOUNTED and is told `open`: Radix owns the scrim's pointer lock and
   the focus trap, and must see the close to release them. */
const FORMATS = [
  { k: 'markdown', label: 'Markdown', hint: '.md — portable, and lossless for prose' },
  { k: 'html', label: 'HTML', hint: '.html — styled, self-contained' },
  { k: 'pdf', label: 'PDF', hint: 'through your browser’s print dialog' },
]

export default function ExportSheet({ open, onClose, word, terms = null }) {
  const [format, setFormat] = useState('markdown')
  const [meta, setMeta] = useState(true)
  const run = () => {
    if (!word) return
    const title = word.name || 'untitled'
    if (format === 'markdown') download(fileName(title, 'md'), buildMarkdown(word, { meta, terms }), 'text/markdown;charset=utf-8')
    else if (format === 'html') download(fileName(title, 'html'), buildHTML(word, { meta }), 'text/html;charset=utf-8')
    else printHTML(buildHTML(word, { meta }))
    onClose()
  }
  /* THE KIT'S OWN DIALOG DRESS (audit 2026-10-02): the sheet wore a class no
     stylesheet defined — no width, no padding, its title running under the
     close × and out of the plate. The kit Modal's `title` / `lead` / `size`
     head it in the house dialog voice, as Ink's Export note is. */
  return <Modal open={!!(open && word)} onClose={onClose} label={`Export ${word?.name || ''}`} size="md"
      title="Export word" lead={<span {...qh('Export', 'Save this word as a file — the word, its definition, and (if you keep the facts) its tags, aliases, synonyms, antonyms and standing.')}><em>{word?.name}</em>, as a file.</span>}>
    <div role="radiogroup" aria-label="Format"
      {...qh('Format', 'Markdown keeps the prose portable. HTML is a styled page that stands on its own. PDF opens the print dialog on that page.')}>
      {FORMATS.map(f => <SettingsRow key={f.k} label={f.label} description={f.hint}
        control={<Button size="sm" variant={format === f.k ? 'solid' : 'outline'} role="radio" aria-checked={format === f.k} onClick={() => setFormat(f.k)}>{format === f.k ? 'Chosen' : 'Choose'}</Button>} />)}
    </div>
    <SettingsRow label="Include the word’s facts" description={format === 'markdown' ? 'Tags, aliases, synonyms, antonyms, standing — as frontmatter.' : 'Tags, aliases, synonyms, antonyms, standing — a line under the word.'}
      control={<Toggle checked={meta} onChange={e => setMeta(e.target.checked)} />}
      {...qh('Include the facts', 'Tags, aliases, synonyms, antonyms, standing and the commitment date — as frontmatter in Markdown, as a line under the word in HTML and PDF.')} />
    <div className="ofself-modal-actions">
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="solid" onClick={run} {...qh('Export', format === 'pdf' ? 'Opens the page in a new tab and calls the print dialog.' : 'Downloads the file.')}>Export</Button>
    </div>
  </Modal>
}
